var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelTimeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92143 12.4775C5.74512 12.6538 5.54289 12.742 5.31473 12.742C5.08657 12.742 4.88952 12.659 4.72359 12.4931C4.55766 12.3271 4.47987 12.1353 4.49024 11.9175C4.49024 11.6893 4.5784 11.4871 4.7547 11.3108L11.1328 4.93267C11.3091 4.75637 11.5113 4.66821 11.7395 4.66821C11.9677 4.66821 12.1647 4.75118 12.3306 4.91711C12.4966 5.08305 12.5795 5.2801 12.5795 5.50826C12.5692 5.72605 12.4758 5.92309 12.2995 6.0994L5.92143 12.4775ZM12.3462 12.5553C12.1595 12.742 11.9365 12.8405 11.6773 12.8509C11.4284 12.8509 11.2106 12.7575 11.0239 12.5708L4.59914 6.14607C4.40209 5.94902 4.30357 5.72605 4.30357 5.47714C4.31394 5.21787 4.41765 4.98971 4.61469 4.79266C4.81174 4.59562 5.02953 4.50228 5.26806 4.51265C5.51696 4.51265 5.73994 4.61117 5.93699 4.80822L12.3462 11.2174C12.5432 11.4145 12.6418 11.6375 12.6418 11.8864C12.6418 12.1353 12.5432 12.3582 12.3462 12.5553Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelTimeButton);
export default __webpack_public_path__ + "static/media/CancelTimeButton.1ebe64bc64e7401c9b871b9004f6a462.svg";
export { ForwardRef as ReactComponent };